import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";
const OrganizationUserService = {
  getList: async ({ pageNumber, pageSize }) => {
    const response = await apiService.get(`/${slug}/organizationuser?pageNumber=${pageNumber}&pageSize=${pageSize}`);
    console.log("🚀 ~ getList: ~ response:", response);
    return response.data;
  },
}

export default OrganizationUserService